import type { ReactElement } from 'react';
import { FormattedMessage } from 'react-intl';

export const EditorRefreshBannerContent = (): ReactElement => {
  return (
    <span data-testid="editor-refresh-banner">
      <FormattedMessage
        id="Refreshing latest event data..."
        defaultMessage="Refreshing latest event data..."
        description="Editor-only banner shown while fresh event data is loading"
      />
    </span>
  );
};
